const SETTOASTTIME = 'SETTOASTTIME';
const SETLANG = 'SETLANG';
const SETFOCUSWATCH = 'SETFOCUSWATCH';
const SETDEVICENAME = 'SETDEVICENAME';


export default {
    SETTOASTTIME,
    SETLANG,
    SETFOCUSWATCH,
    SETDEVICENAME,
};